import { Outlet } from "react-router-dom";

export interface AppProps {}

export default function GuestLayoutApp(props: AppProps) {
  return <Outlet />;
}
